import { PostCarousels } from "./../js/post-carousels";
import { GenericCarousels } from "../js/generic-carousels";

import { Survey } from "./survey/survey";
import { HomePage } from "../js/home-page/home-page";
import { OfferPage } from "../js/offer/offer-page";
import { HelpPage } from "../js/help-page/help-page";
// Webpack Imports
import * as bootstrap from "bootstrap";
import UHMobileNav from "../js/mobileNavigation";
import { BASE_SURVEY_SELECTOR } from "./survey/survey.constants";
import Product from "../js/product/product";
// import Swiper JS
import Swiper, {
  Pagination,
  Navigation,
  Autoplay,
  EffectFade,
  Scrollbar,
} from "swiper";
import { InfoUtente, LoginLocalStorageData } from "../js/header.models";

// tracking
import { TrackingUtils } from "../js/trackings.utils";
import {
  AnalyticsSupportTypeName,
  SurveySupportType,
} from "../assets/survey/survey-models";
import { OfferCarousels } from "../js/offer-carousels";

(function () {
  "use strict";

  initSurvey();
  initAllPage();
  Product.init();
  UHMobileNav.init();

  // Focus input if Searchform is empty
  [].forEach.call(
    document.querySelectorAll(".search-form"),
    (el: HTMLFormElement) => {
      el.addEventListener("submit", function (e) {
        var search: HTMLInputElement | null = el.querySelector("input");
        if (search && search.value.length < 1) {
          e.preventDefault();
          search.focus();
        }
      });
    }
  );

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (
    popoverTriggerEl: HTMLElement
  ) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
  //Saves marketing tracking ID in sessionStorage
  if (new URLSearchParams(location.search).get("cmp")) {
    sessionStorage.setItem(
      "cmp",
      new URLSearchParams(location.search).get("cmp")
    );
  } else {
    if (!sessionStorage.getItem("cmp")) {
      sessionStorage.removeItem("cmp");
    }
  }
})();

// STICKY HEADER
const header = document.getElementById("header");
let lastScroll = 0;

const validateHeader = () => {
  const windowY = window.scrollY;
  const windowW = window.innerWidth;

  if (header) {
    if (windowY > header.offsetHeight && windowW < 992) {
      //mobile
      // We passed the first section, set a toggable class
      // header.classList.add("is-fixed");
      header.classList.add("box-shadow");
      // Determine is we ready to animate
      if (windowY < lastScroll) {
        // Determine if we scrolling up
        header.classList.add("scroll-up", "box-shadow", "can-animate");
      } else {
        header.classList.remove("scroll-up", "box-shadow");
      }
    } else if (windowY > header.offsetHeight && windowW >= 992) {
      //desktop
      header.classList.add("box-shadow");
    } else {
      header.classList.remove(
        "is-fixed",
        "can-animate",
        "scroll-up",
        "box-shadow"
      );
    }
  }

  lastScroll = windowY;
};

window.addEventListener("scroll", validateHeader);
//inizializzo le cta login / user
initHeaderUser(header);
function initHeaderUser(header: HTMLElement) {
  if (!header) {
    console.error("componente header non trovato");
    return;
  }
  const user: LoginLocalStorageData = JSON.parse(
    localStorage.getItem("info_utente_reducer")
  );
  // const user: User = ...
  if (
    user &&
    user?.info_utente &&
    user?.info_utente?.recupera_info_utente?.result
  ) {
    const ctaUser = header.querySelector<HTMLAnchorElement>("#cta-user");
    ctaUser.classList.remove("d-none");
    ctaUser.querySelector<HTMLSpanElement>(
      "span"
    ).innerText = `${user.info_utente.recupera_info_utente.result.nome[0]}${user.info_utente.recupera_info_utente.result.cognome[0]}`;
    header
      .querySelector<HTMLElement>("#overlay-login-button")
      .querySelector("span").innerText = php_pars.overlay_go_to_portal_text;
  } else {
    const ctaLogin = header.querySelector<HTMLAnchorElement>("#cta-login");
    ctaLogin.classList.remove("d-none");
    ctaLogin.classList.add("d-flex");
  }
}
function initSurvey() {
  const surveyEl = document.querySelector<HTMLElement>(
    "#" + BASE_SURVEY_SELECTOR
  );
  if (surveyEl) {
    new Survey(surveyEl);
  }
}

function initAllPage() {
  new HomePage();
  new OfferPage();
  new PostCarousels();
  new GenericCarousels();
  new OfferCarousels();
  if (document.getElementById("help-page")) new HelpPage();
}

// END STICKY HEADER

// HOMEPAGE REVIEWS CAROUSEL SWIPER
const reviewSwiper = new Swiper(".swiper-reviews", {
  // Optional parameters
  direction: "horizontal",
  modules: [Pagination, Autoplay],
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  loop: true,
  enabled: true,
  simulateTouch: true,

  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 3,
      loop: false,
      enabled: false,
      pagination: {
        el: "",
      },
      autoplay: false,
    },
  },
});

// HOMEPAGE AND BLOGPAGE NEWS CAROUSEL SWIPER
const newsSwiper = new Swiper(".swiper-news", {
  // Optional parameters
  direction: "horizontal",
  modules: [Navigation, Scrollbar],
  allowTouchMove: true,
  enabled: true,
  slidesPerView: 1.2,
  resizeObserver: true,
  navigation: {
    nextEl: ".correlated-button-next",
    prevEl: ".correlated-button-prev",
  },
  centeredSlides: true,
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 35,
      centeredSlides: false,
    },
  },
});

newsSwiper.on("breakpoint", function () {
  newsSwiper.navigation.destroy();
  newsSwiper.navigation.init();
});

export function renderTooltip(): void {
  const tooltip = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltip.forEach((t) => {
    new bootstrap.Tooltip(t);
  });
}

renderTooltip();

const telCard = document.getElementById("telCard");
const cardOneLabel = document.getElementById("cardOneLabel");
const telNumber = document.getElementById("telNumber");
if (telCard) {
  telCard.addEventListener("click", () => {
    cardOneLabel.classList.add("d-none");
    telNumber.classList.remove("d-none");
  });
}

const tracking = new TrackingUtils();

const helpBtns = document.querySelectorAll<HTMLElement>(".help-btn");
if (helpBtns && helpBtns.length > 0) {
  helpBtns.forEach((btn) => {
    const redirectEl = btn.querySelectorAll<HTMLAnchorElement>("a")[0];
    redirectEl?.addEventListener("click", () => {
      // console.log("ededed");

      tracking.trackSurveySupportButton(
        AnalyticsSupportTypeName.get(btn.id as SurveySupportType)
      );
    });
  });
}



document.addEventListener("DOMContentLoaded", function () {
  let openbuttons = document.getElementsByClassName("accordion-open-button");

  // Function to close all accordions on page load
  function closeAllAccordions() {
    for (let i = 0; i < openbuttons.length; i++) {
      const elem = openbuttons[i] as HTMLElement;
      let accordionItem = elem.closest(".accordion-item");

      // Ensure the accordion is closed
      accordionItem.classList.add("hide");
      elem.textContent = "+";
    }
  }

  // Close all accordions on page load
  closeAllAccordions();

  // Add event listeners to toggle accordion state on click
  for (let i = 0; i < openbuttons.length; i++) {
    openbuttons[i].addEventListener("click", function (e) {
      const elem = e.target as HTMLElement;
      e.preventDefault();
      let accordionItem = elem.closest(".accordion-item");

      accordionItem.classList.toggle("hide");
      console.log(accordionItem);

      // Toggle the text content between "+" and "-"
      if (elem.textContent === "+") {
        elem.textContent = "–";
      } else {
        elem.textContent = "+";
      }
    });
  }
});
